/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrganizationStateType = {
    Served: 'Served',
    Unserved: 'Unserved'
} as const;
export type OrganizationStateType = typeof OrganizationStateType[keyof typeof OrganizationStateType];


export function OrganizationStateTypeFromJSON(json: any): OrganizationStateType {
    return OrganizationStateTypeFromJSONTyped(json, false);
}

export function OrganizationStateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationStateType {
    return json as OrganizationStateType;
}

export function OrganizationStateTypeToJSON(value?: OrganizationStateType | null): any {
    return value as any;
}

